export default __webpack_public_path__ + "static/media/AIG_FI.828fe133.png";